import { ArpMediaType } from '@arpeggi/shared'
import { useCallback, useEffect, useState } from 'react'
import { IArpMedia } from '../../../../../features/arp-registry/ArpMedia'
import ArpRegistry from '../../../../../features/arp-registry/ArpRegistry'
import { useTreeState } from '../../../../stores/Root'

interface AdditionalData {
  queueData?: number[]
}

const useSelectedMedia = (additionalData: AdditionalData = {}) => {
  const { globalPlayer } = useTreeState()
  const [selected, setSelected] = useState<{ id: number; type: ArpMediaType } | undefined>()
  const [media, setMedia] = useState<IArpMedia | undefined>(undefined)
  const index = globalPlayer.arpMediaIndex || -1
  const type = selected?.type || ArpMediaType.SAMPLE

  const handleSelect = useCallback(
    async ({ id }: { id: number }) => {
      await globalPlayer.setArpMediaIndex(id === selected?.id || !id ? null : id)

      if (additionalData.queueData && additionalData.queueData.length > 0) {
        const selectedIndex = additionalData.queueData.indexOf(id)
        globalPlayer.setQueue(additionalData.queueData.slice(selectedIndex + 1))
      } else {
        globalPlayer.clearQueue()
      }
      globalPlayer.play()
    },
    [selected, additionalData]
  )

  useEffect(() => {
    if (!globalPlayer.arpMediaIndex) {
      setSelected(undefined)
      setMedia(undefined)
    } else {
      ArpRegistry.getByIdAsync(globalPlayer.arpMediaIndex).then((arp) => {
        setSelected({ id: arp.id, type: arp.type })
        setMedia(arp)
      })
    }
  }, [globalPlayer.arpMediaIndex])

  return { handleSelect, index, type, media }
}

export default useSelectedMedia
